import axios from "axios";
import { Component } from "react";
import { setHeaderAuth } from "../utils";
import { WEB_API_UPLOAD } from "../env";

class ApiContent extends Component {
  static get = async () => {
    await setHeaderAuth();
    const result = await axios({
      url: "content",
      method: "get",
    });
    return result;
  };
  static update = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: WEB_API_UPLOAD + "content",
      method: "put",
      data: data,
    });
    return result;
  };
  static delete = async (data) => {
    await setHeaderAuth();
    const result = await axios({
      url: `mt_policys/${data.policy_id}`,
      method: "delete",
    });
    return result;
  };
}

export default ApiContent;
